import { IProduct } from 'featureSliced/shared/store/reducers/CategoriesReducer/types'
import { IBucketProduct } from 'featureSliced/shared/store/reducers/QRMenuBucketReducer/types'

export const isProductSoldOut = (
  product: Pick<IProduct, 'id' | 'soldOut'> | null | undefined,
  soldOutIds: number[] = []
): boolean =>
  Boolean(product?.soldOut) ||
  (product?.id !== undefined && soldOutIds.includes(product.id))

export const findSoldOutLines = (
  bucketProducts: IBucketProduct[] = [],
  soldOutIds: number[] = []
): IBucketProduct[] =>
  soldOutIds.length
    ? bucketProducts.filter((line) => soldOutIds.includes(line.productId))
    : []

export const SOLD_OUT_REFUSAL_CODE = 'ARTICLE_SOLD_OUT'

type RefusalLike = { code?: unknown; data?: { productIds?: unknown } }

export const isSoldOutRefusal = (error: unknown): error is RefusalLike =>
  (error as RefusalLike | null | undefined)?.code === SOLD_OUT_REFUSAL_CODE

export const getRefusedProductIds = (error: RefusalLike): number[] => {
  const ids = error?.data?.productIds
  return Array.isArray(ids) ? ids.map(Number).filter(Number.isFinite) : []
}
